import { useSliderContext } from '@cian/slider';

import type { IBuildingPhoto } from 'shared/types/buildingCard';

import { useDragScroll } from '../../hooks';

import style from './style.css';

export interface IGalleryThumbsProps {
  photos: IBuildingPhoto[];
  /** alt по фото */
  alts: string[];
}

export const GalleryThumbs = ({ photos, alts }: IGalleryThumbsProps) => {
  const { currentSlide, scrollTo } = useSliderContext();
  const dragHandlers = useDragScroll();

  return (
    <ul className={style['container']} data-name="GalleryThumbs" {...dragHandlers}>
      {photos.map(({ thumbnailUrl }, index) => (
        <li key={`${thumbnailUrl}-${index}`}>
          <button
            type="button"
            className={index === currentSlide ? `${style['thumb']} ${style['thumb--active']}` : style['thumb']}
            aria-current={index === currentSlide}
            onClick={() => scrollTo(index)}
          >
            <img className={style['image']} src={thumbnailUrl} alt={alts[index]} loading="lazy" />
          </button>
        </li>
      ))}
    </ul>
  );
};
